/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaTypeEnum } from './MediaTypeEnum';
import {
    MediaTypeEnumFromJSON,
    MediaTypeEnumFromJSONTyped,
    MediaTypeEnumToJSON,
    MediaTypeEnumToJSONTyped,
} from './MediaTypeEnum';

/**
 * Serializer for PerformerMedia model.
 * @export
 * @interface PerformerMedia
 */
export interface PerformerMedia {
    /**
     * 
     * @type {string}
     * @memberof PerformerMedia
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof PerformerMedia
     */
    performer: string;
    /**
     * 
     * @type {MediaTypeEnum}
     * @memberof PerformerMedia
     */
    mediaType?: MediaTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PerformerMedia
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PerformerMedia
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PerformerMedia
     */
    file: string;
    /**
     * 
     * @type {number}
     * @memberof PerformerMedia
     */
    readonly fileSize: number | null;
    /**
     * YouTube, Spotify, SoundCloud, etc.
     * @type {string}
     * @memberof PerformerMedia
     */
    externalUrl?: string;
    /**
     * Use as primary photo/media for this performer
     * @type {boolean}
     * @memberof PerformerMedia
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PerformerMedia
     */
    uploadedBy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PerformerMedia
     */
    readonly uploadedByName: string;
    /**
     * 
     * @type {Date}
     * @memberof PerformerMedia
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PerformerMedia
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the PerformerMedia interface.
 */
export function instanceOfPerformerMedia(value: object): value is PerformerMedia {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('performer' in value) || value['performer'] === undefined) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined) return false;
    if (!('uploadedByName' in value) || value['uploadedByName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PerformerMediaFromJSON(json: any): PerformerMedia {
    return PerformerMediaFromJSONTyped(json, false);
}

export function PerformerMediaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PerformerMedia {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'performer': json['performer'],
        'mediaType': json['media_type'] == null ? undefined : MediaTypeEnumFromJSON(json['media_type']),
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'file': json['file'],
        'fileSize': json['file_size'],
        'externalUrl': json['external_url'] == null ? undefined : json['external_url'],
        'isPrimary': json['is_primary'] == null ? undefined : json['is_primary'],
        'uploadedBy': json['uploaded_by'] == null ? undefined : json['uploaded_by'],
        'uploadedByName': json['uploaded_by_name'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function PerformerMediaToJSON(json: any): PerformerMedia {
      return PerformerMediaToJSONTyped(json, false);
  }

  export function PerformerMediaToJSONTyped(value?: Omit<PerformerMedia, 'id'|'file_size'|'uploaded_by_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'performer': value['performer'],
        'media_type': MediaTypeEnumToJSON(value['mediaType']),
        'title': value['title'],
        'description': value['description'],
        'file': value['file'],
        'external_url': value['externalUrl'],
        'is_primary': value['isPrimary'],
        'uploaded_by': value['uploadedBy'],
    };
}

